import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const targetId = this.element.dataset.scrollToTarget
    if (targetId) {
      const target = document.getElementById(targetId)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
